import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox } from 'antd'

import GroupDragAndDropIcon from './../general/icons/GroupDragAndDropIcon'
import Input from '../dataEntry/inputs/Input'
import DropDown from '../dataEntry/inputs/DropDown'
import CrossIcon from './../general/icons/CrossIcon'
import MetaDefaultValueInput from './../dataEntry/inputs/MetaDefaultValuesInput'

import _ from 'lodash'
import './../ui.style.scss'
import { utilityService } from '../../../services/UtilityService'
import { DATE_TIME_TYPE, FILE_TYPE, RICH_TEXT_TYPE } from 'constants/general-constants'
import MultipleDropDown from '../dataEntry/inputs/MultipleDropDown'

const listType = [
  {
    name: 'BOOLEAN',
    value: 'BOOLEAN'
  }, {
    name: 'STRING',
    value: 'STRING'
  }, {
    name: 'INTEGER',
    value: 'INTEGER'
  }, {
    name: 'LIST',
    value: 'LIST'
  },
  DATE_TIME_TYPE,
  RICH_TEXT_TYPE,
  FILE_TYPE
]

class GeneralFieldCell extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      details: props.field,
      showWarning: false
    }
  }

  UNSAFE_componentWillReceiveProps (nextProps) { // eslint-disable-line camelcase
    if (!_.isEqual(nextProps.field, this.props.field)) {
      this.setState({ details: nextProps.field })
    }
  }

  onCloseField = (index) => {
    this.props.onCloseField(index)
  }

  onRemoveProperty = () => {
    this.setState({ showWarning: true })
  }

  closeWarningMessage=() => {
    this.setState({ showWarning: false })
  }

  render () {
    const { details } = this.state
    const { metaSectionLists, placeHolder1, placeHolder2, placeHolder3, index, onOptionSelect, handleChange, handleDefaultValues, handleToolTip, onChangeStatus, nameParam, isSports, isDisabled, type, optionList, isFromEdit, enableButton, handleDisplayTitle, fileList, hasFileTypeSelectedInAnyRow = '' } = this.props
    const groupId = isSports ? utilityService.makeRandomString(6) : 'group'
    const selectedFieldType = details.type
    const multiDropdownId = `multi-dropdown-${details.id}`
    return (
      <div className='channel-stream-cell channel-stream-general'>

        <div className='stream-name'>
          {isDisabled ? <div className='disable-drag' /> : <GroupDragAndDropIcon />}
          <Input title='Title' placeholder={placeHolder1} inputName='title' value={details[nameParam]} handleChange={(e) => handleChange(e, index)} readOnly={isDisabled} />
        </div>
        <div className='stream-name'>
          {/* This is mapped to displayTitle in Schema baes on Requirement */}
          <Input placeholder={'Display Name'} inputName='displayTitle' value={details.displayTitle} handleChange={(e) => handleDisplayTitle(e, index)} readOnly={isDisabled} />
        </div>
        {type !== 'app' ? <div className='group' id={groupId}>
          <DropDown options={type === 'appConfig' || type === 'appWidget' || type === 'channel-steam' ? optionList : listType}
            onOptionSelect={(value) => onOptionSelect(value, index, 'type')} selectedValue={selectedFieldType} valueParam='value' displayParam='name' placeHolder={placeHolder2} parent={groupId} disabled={type === 'channel-steam' ? !details.isEnable : isDisabled || isFromEdit} />
        </div> : null}
        <div
          className={`
            file-extension-type 
            ${hasFileTypeSelectedInAnyRow ? '' : 'd-none'}
            ${selectedFieldType === FILE_TYPE.value ? 'visible' : 'invisible'}
          `}
          id={multiDropdownId}
        >
          <MultipleDropDown
            options={fileList}
            displayParam='key'
            keyParam='key'
            placeHolder='Select File Types'
            parent={multiDropdownId}
            selectedValue={details.supportedFileTypes?.map(item => {
              return {
                id: item,
                key: item
              }
            })}
            onOptionSelect={value => {
              const selectedArray = value.map(fileItem => fileItem.key)
              onOptionSelect(selectedArray, index, 'supportedFileTypes')
            }}
            allowClear
            // showExtraOptionLabel
          />
        </div>

        {type === 'meta' ? <div className='group' id={groupId}>
          <DropDown options={metaSectionLists} allowClear onOptionSelect={(value) => onOptionSelect(value, index, 'section')} selectedValue={details.section} valueParam='id' displayParam='title' placeHolder={placeHolder3} parent={groupId} disabled={type === 'channel-steam' ? !details.isEnable : isDisabled || isFromEdit} />
        </div> : null}
        <div className='stream-name' >
          <Input placeholder={'Tooltip'} inputName='tooltip' value={details.tooltip} handleChange={(e) => handleToolTip(e, index)} readOnly={isDisabled} />
        </div>

        <div className='default-values' >
          <MetaDefaultValueInput enableButton={enableButton} title='Default Values' type={details.type} placeholder={'Enter Default Values'} inputName='defaultValues' value={details.values ? details.values : []} handleChange={handleDefaultValues} index={index}
            disabled={details.type === 'BOOLEAN' || details.type === 'INTEGER' || details.type === DATE_TIME_TYPE.value || details.type === RICH_TEXT_TYPE.value || selectedFieldType === FILE_TYPE.value}
            readOnly
          />
        </div>

        <div className={'required'}>
          {type !== 'app' ? <Checkbox checked={details.isRequired} onChange={(e) => onChangeStatus(e, index)} disabled={details.type === 'BOOLEAN'} /> : null}

          {isDisabled ? <div className='disable-close' /> : (type !== 'appConfig' && type !== 'app' ? <CrossIcon onClick={() => this.onCloseField(index)} /> : null)}
        </div>
      </div>
    )
  }
}
GeneralFieldCell.propTypes = {
  /** file name of GeneralFieldCell. */
  name: PropTypes.string,
  /** close action of GeneralFieldCell. */
  onClose: PropTypes.func,
  /** File index of GeneralFieldCell. */
  index: PropTypes.number,
  /** List of options */
  optionList: PropTypes.array,
  /** Placeholder name of column 1 */
  placeHolder1: PropTypes.string,
  /** Placeholder name of column 2 */
  placeHolder2: PropTypes.string,
  /** Parameter name */
  nameParam: PropTypes.string
}

GeneralFieldCell.defaultProps = {
  nameParam: 'name'
}

export default GeneralFieldCell
